export const FETCH_DISTLIST_BEGIN = 'FETCH_DISTLIST_BEGIN';
export const FETCH_DISTLIST_SUCCESS = 'FETCH_DISTLIST_SUCCESS';
export const FETCH_DISTLIST_ERROR = 'FETCH_DISTLIST_ERROR';
